<section class="dynamic-form-pagination-wrapper">
    <div class="header" *ngIf="selectedFormData">
        <div class="data-indicator" *ngIf="isRightRangeEnabled || isLeftRangeEnabled">
            {{data?.length - (selectedIndex) + '/' + data?.length }}
        </div>
        <div class="navigation-button-wrapper">
            <button dlsButton class="pt-icon-only pt-quiet navigation-button"
                    [disabled]="!isRightRangeEnabled"
                    (click)="onRangeSelection('left')">
                <dls-icon class="pt-icon icon-dls-navigation-left"></dls-icon>
            </button>
            <button dlsButton class="pt-icon-only title pt-quiet-default navigation-button">
                {{selectedFormData[titleParam]| date:'dd MMM yyyy'}}
            </button>
            <button dlsButton class="pt-icon-only pt-quiet navigation-button"
                    [disabled]="!isLeftRangeEnabled"
                    (click)="onRangeSelection('right')">
                <dls-icon class="pt-icon icon-dls-navigation-right"></dls-icon>
            </button>
        </div>
    </div>
    <div class="dynamic-form-pagination">
        <gen-dynamic-form
                [formData]="selectedFormData"
                [formConfig]="formConfig"
                [formName]="formId"
                [popupMode]="true"
                [editMode]="true"
                [disabled]="true"
                [formVertical]="false"
                [listenToDataChange]="true"
        ></gen-dynamic-form>
    </div>
</section>
